import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { DateTime, IdStartEnd, SelectableItem, TimeframeItem } from "../../types";
import Date from "../Inputs/Date";
import Dropdown from "../Inputs/Dropdown";

const AddTimePeriod = (props: any) => {
	let timeframes: TimeframeItem[] = useSelector((state: any) => state.timeframes.value);
	let [period, setPeriod] = useState({
		id: 0
	} as IdStartEnd);

	return (
		<Dialog open={true} onClose={props.Close}>
			<DialogContent className="px-5 mt-3">
				<Dropdown Size={12}
					Class="mb-0"
					Label="Timeframe"
					Options={timeframes
						.map(t => {
							return {
								Id: t.timeframeId,
								Value: t.longDescription
							} as SelectableItem;
						})}
					Index={0}
					Value={period.id}
					OnChange={UpdateTimeframe} />
				<Date Size={6} Label="Start Date" OnChange={UpdateStartDate} NoError />
				<Date Size={6} Label="End Date" OnChange={UpdateEndDate} NoError />
				{`The new dates cannot overlap other active time periods.`}
			</DialogContent>
			<DialogActions className="px-3">
				<Button className="mx-3 my-4" onClick={props.Close} variant="outlined">Cancel</Button>
				<Button onClick={() => props.Confirm(period)} variant="contained" className="bg-success mx-3">Confirm</Button>
			</DialogActions>
		</Dialog>
	);

	function UpdateStartDate(newValue: any) {
		let item = ({ ...period, startDate: new DateTime(newValue) });
		setPeriod(item);
	}
	function UpdateEndDate(newValue: any) {
		let item = ({ ...period, endDate: new DateTime(newValue) });
		setPeriod(item);
	}
	function UpdateTimeframe(newValue: any) {
		let item = ({ ...period, id: newValue, timeframe: timeframes.find(t => t.timeframeId === newValue) });
		setPeriod(item);
	}
}

export default AddTimePeriod;